<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="예약정보">
      <template v-slot:offcanvas>
        <customer-detail-offcanvas />
        <noti-send-offcanvas />
      </template>
      <template v-slot:header-menu>
        <div class="hstack gap-2">
          <div class="dropdown">
            <button
              class="btn btn-light dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              <color-badge :color="color" />
              색상
            </button>
            <ul class="dropdown-menu">
              <li v-for="c in colors" :key="c" @click="clickColor(c)">
                <a href="javascript:0" class="dropdown-item text-black-50">
                  <color-badge :color="c" @click="clickColor(c)" />
                  {{ c }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex gap-1">
          <epi-select placeholder="고객명" style="width: 160px" />
          <button
            class="btn btn-primary flex-grow-1"
            @click="openNotiSendOffcanvas"
          >
            알림 전송
          </button>
          <button
            class="btn btn-outline-primary flex-grow-1"
            @click="openCustomerDetailOffcanvas"
          >
            정보 확인
          </button>
        </div>

        <div
          class="p-3 rounded"
          style="background-color: rgba(var(--epi-primary-rgb), 0.2)"
        >
          <epi-select v-model="selectedShowType" :candidates="showTypes" />

          <div class="mb-2"></div>

          <template v-if="selectedShowType !== showCanceled">
            <div class="form-check">
              <label class="form-check-label">
                <input
                  type="radio"
                  class="form-check-input"
                  name="price"
                  @click="
                    price = defaultPrice[selectedShowType];
                    customPriceVisible = false;
                  "
                />
                {{ defaultPrice[selectedShowType] }} 원</label
              >
            </div>

            <div class="form-check">
              <label class="form-check-label">
                <input
                  type="radio"
                  class="form-check-input"
                  name="price"
                  @click="
                    price = 0;
                    customPriceVisible = true;
                  "
                />
                다른 가격</label
              >
            </div>

            <div class="mb-2"></div>

            <template v-if="customPriceVisible">
              <input type="number" class="form-control" v-model="price" />
              <div class="mb-2"></div>
            </template>

            <button class="btn btn-outline-primary w-100">등록</button>
          </template>
        </div>

        <div class="d-flex flex-row gap-1">
          <div>
            <label>날짜</label>
            <epi-date-picker />
          </div>
          <div>
            <label>시작 시간</label>
            <input type="time" class="form-control" />
          </div>
          <div>
            <label>진행 시간(분)</label>
            <input type="number" class="form-control" placeholder="50" />
          </div>
        </div>

        <div class="hstack gap-4">
          <div class="form-check" v-for="t in placeTypes" :key="t">
            <label class="form-check-label">
              <input type="radio" class="form-check-input" name="placeType" />
              {{ t }}</label
            >
          </div>
        </div>

        <div class="d-flex align-items-center">
          <label class="me-3">결제방법</label>
          <epi-select placeholder="이용권" class="flex-fill" />
        </div>

        <div class="row">
          <div class="col-8 pe-0">
            <label class="form-label">이용권</label>
            <epi-select placeholder="888" />
          </div>
          <div class="col-4">
            <label class="form-label">잔여 횟수</label>
            <input type="number" class="form-control" placeholder="1" />
          </div>
        </div>

        <div class="row">
          <div class="col-8 pe-0">
            <label class="form-label">종류</label>
            <epi-multi-select
              v-model="selectedMeetingTypes"
              :candidates="meetingTypes"
            />
          </div>
          <div class="col-4">
            <label class="form-label">비용(원)</label>
            <input type="number" class="form-control" placeholder="0" />
          </div>
        </div>

        <div>
          <hr class="mt-0 pt-0" />
          <input type="text" class="form-control" placeholder="메모" />
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <button class="btn btn-light">
            <i class="bi bi-trash"></i>
          </button>
          <div class="hstack gap-2">
            <button class="btn btn-light" data-bs-dismiss="modal">취소</button>
            <button class="btn btn-outline-primary">확인</button>
          </div>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { Color, EventName } from "@/const";

const willAttend = "참석예정";
const noShow = "노쇼";
const showCanceled = "취소";
const defaultPrice = {
  [willAttend]: 60000,
  [noShow]: 0,
};
const placeTypeRemote = "화상상담";
const placeTypeCall = "전화상담";
const placeTypeInPerson = "대면상담";

export default {
  name: "EventDetailModal",
  data() {
    return {
      modal: null,
      colors: Object.keys(Color),
      color: Object.keys(Color)[0],
      willAttend,
      noShow,
      showCanceled,
      defaultPrice,
      showTypes: [willAttend, noShow, showCanceled],
      selectedShowType: willAttend,
      customPriceVisible: false,
      price: defaultPrice[willAttend],
      placeTypeRemote,
      placeTypeCall,
      placeTypeInPerson,
      placeTypes: [placeTypeRemote, placeTypeCall, placeTypeInPerson],
      openingEventName: EventName.EventDetailModalOpening,
      meetingTypes: ["개인상담", "집단상담"],
      selectedMeetingTypes: [],
    };
  },
  methods: {
    clickColor(c) {
      this.color = c;
    },
    openNotiSendOffcanvas() {
      this.$root.$emit(EventName.NotiSendOffcanvasOpening);
    },
    openCustomerDetailOffcanvas() {
      this.$root.$emit(EventName.CustomerDetailOffcanvasOpening);
    },
  },
  mounted() {},
};
</script>
